import React from 'react';
import { connect } from 'react-redux';

import DashboardCard from '@modules/common/components/DashboardCard';
import { StoreState } from '@src/meta/types/store';
import { AccountInfo } from '@modules/auth/components/types/user/index';

import ExistingClients from './ExistingClients';

type PropsFromStore = {
  account?: AccountInfo;
};

function OAuthClients({ account }: PropsFromStore) {
  if (!account) {
    return null;
  }
  return (
    <DashboardCard style={{ marginTop: '20px', minHeight: '470px' }} height="auto">
      <ExistingClients account={account} />
    </DashboardCard>
  );
}

const mapStateToProps = (state: StoreState): PropsFromStore => ({
  account: state.account.account,
});

export default connect(mapStateToProps)(OAuthClients);
